/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetEtcCards200ResponseItemsInnerUser } from './get-etc-cards200-response-items-inner-user';
// May contain unused imports in some cases
// @ts-ignore
import { GetEtcCards200ResponseItemsInnerUserAccountGroup } from './get-etc-cards200-response-items-inner-user-account-group';

/**
 * 
 * @export
 * @interface GetEtcCards200ResponseItemsInner
 */
export interface GetEtcCards200ResponseItemsInner {
    /**
     * User account ID
     * @type {string}
     * @memberof GetEtcCards200ResponseItemsInner
     */
    'userAccountId': string;
    /**
     * Card label (display name)
     * @type {string}
     * @memberof GetEtcCards200ResponseItemsInner
     */
    'cardLabel': string;
    /**
     * Card status
     * @type {string}
     * @memberof GetEtcCards200ResponseItemsInner
     */
    'status': GetEtcCards200ResponseItemsInnerStatusEnum;
    /**
     * 
     * @type {GetEtcCards200ResponseItemsInnerUser}
     * @memberof GetEtcCards200ResponseItemsInner
     */
    'user'?: GetEtcCards200ResponseItemsInnerUser | null;
    /**
     * Card creation date
     * @type {string}
     * @memberof GetEtcCards200ResponseItemsInner
     */
    'createdAt': string;
    /**
     * Last 4 digits of the ETC ID. Null when not yet assigned or unavailable.
     * @type {string}
     * @memberof GetEtcCards200ResponseItemsInner
     */
    'etcIdLastFourDigits'?: string | null;
    /**
     * 
     * @type {GetEtcCards200ResponseItemsInnerUserAccountGroup}
     * @memberof GetEtcCards200ResponseItemsInner
     */
    'userAccountGroup'?: GetEtcCards200ResponseItemsInnerUserAccountGroup | null;
}

export const GetEtcCards200ResponseItemsInnerStatusEnum = {
    issuing: 'ISSUING',
    active: 'ACTIVE',
    deactivated: 'DEACTIVATED'
} as const;

export type GetEtcCards200ResponseItemsInnerStatusEnum = typeof GetEtcCards200ResponseItemsInnerStatusEnum[keyof typeof GetEtcCards200ResponseItemsInnerStatusEnum];


